import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Hero from "@/components/Hero";
import PartyMarquee from "@/components/PartyMarquee";
import Countdown from "@/components/Countdown";
import BentoNav from "@/components/BentoNav";
import EventDetails from "@/components/EventDetails";
import RSVP from "@/components/RSVP";
import Footer from "@/components/Footer";
import Admin from "@/components/Admin";

const Home = () => {
    return (
        <main data-testid="home-page" className="min-h-screen">
            <Hero />
            <PartyMarquee />
            <Countdown />
            <BentoNav />
            <EventDetails />
            <PartyMarquee />
            <RSVP />
            <Footer />
        </main>
    );
};

function App() {
    return (
        <div className="App">
            <Toaster
                position="top-center"
                toastOptions={{
                    style: {
                        border: "4px solid #111",
                        borderRadius: "16px",
                        fontFamily: "Fredoka, Nunito, sans-serif",
                        fontWeight: 600,
                        boxShadow: "6px 6px 0 0 rgba(0,0,0,1)",
                    },
                }}
            />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/admin-christopher" element={<Admin />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
